const translations = {
  fr: {
    notifications: {
      estimationSuccess: 'Votre estimation a été calculée',
      estimationClickHere: 'Cliquez ici pour voir l\'estimation',
    },
  },
  en: {
    notifications: {
      estimationSuccess: 'The estimation has been calculated',
      estimationClickHere: 'Click here to view your estimation',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/notifications/i18n/notifications.js